import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import TransactionsTable from "@/components/schools/TransactionsTable";
import { TRANSACTIONS } from "@/help/fixtures";

export default function TrackingDonations() {
  return (
    <>
      <p>
        Your <strong>Donations</strong> page is the running list of every donation that's come in. It's the page to check when someone says "did my $50 go through?" or when you need to find a donation to issue a refund.
      </p>

      <Screenshot caption="The list of donations">
        <TransactionsTable
          donations={TRANSACTIONS.map((d) => ({
            ...d,
            classroom_name: "Room 12",
            anonymous: !!d.anonymous,
            provider: "square",
            provider_dashboard_url: "#",
          }))}
        />
      </Screenshot>

      <p>
        Each row tells you who gave, which student they donated to, how much your school received, and what their card was charged (those numbers differ when the donor covered the fee). The status tells you whether it went through, is still processing, was declined, or was refunded. The <strong>View in Square</strong> link on each row pops it open in your Square dashboard for cross-checking.
      </p>

      <Callout variant="privacy" title="Donor names and emails stay between you and us">
        <p>
          Teachers don't see this page. Here you see every donor's name, so you can match payments and answer questions; a donor who chose to give anonymously is tagged "Anonymous to the public" and shows as "Anonymous" everywhere else. Donor emails never show publicly.
        </p>
      </Callout>

      <h2>Where the money actually is</h2>
      <p>
        Donations go straight to Square, then to your school's bank account on Square's normal schedule — usually the next business day. PagePledge never holds the money; your dashboard just shows you what Square's already done. The <strong>View in Square</strong> link is helpful when you're matching donations against your bank statement.
      </p>

      <h2>Downloading the list</h2>
      <p>
        We don't have a download button just yet — but every donation also shows up in your Square dashboard, which does. We'll add one here once enough schools ask for it.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/refunds-via-square">Refunding a donation</Link>.</li>
        <li><Link href="/help/articles/fees-and-pricing">How fees and pricing work</Link>.</li>
        <li><Link href="/help/articles/connecting-square">Connecting Square</Link>.</li>
      </ul>
    </>
  );
}
